import Model from './Model';
import Activity from './Activity';
import Customer from './Customer';
import Note from './Note';
import Package from './Package';
import Inventory from './Inventory';

export const PaymentMethods = Object.freeze({
    COMPANY_CHECK: 'company-check',
    DIRECT_DEPOSIT: 'direct-deposit',
    PAYPAL: 'paypal',
});

export const OrderStatuses = Object.freeze({
    KIT_REQUESTED: 'kit-requested',
    KIT_INBOUND: 'kit-inbound',
    KIT_RECEIVED: 'kit-received',
    APPRAISAL: 'appraisal',
    OFFER_GENERATION: 'offer-generation',
    OFFER_READY: 'offer-ready',
    OFFER_ACCEPTED: 'offer-accepted',
    OFFER_DECLINED: 'offer-declined',
    REVERSE_SHIP: 'reverse-ship',
    RETURNED: 'returned',
    SETTLED: 'settled',
    BATCHED: 'batched',
    CLOSED: 'closed',
});

export default class Order extends Model {
    resource () {
        return 'orders';
    }

    get mutations() {
        return {
            activity: Activity,
            customer: Customer,
            notes: Note,
            packages: Package,
            inventory: Inventory,
        };
    }

    activity () {
        return this.hasMany(Activity);
    }

    inventory () {
        return this.hasMany(Inventory);
    }

    notes () {
        return this.hasMany(Note);
    }

    offer () {
        //console.log(this.custom('offers/current').first());
    }

    packages () {
        return this.hasMany(Package);
    }

    addNote (contents) {
        let note = new Note({'contents': contents}).for(this);

        return note.save();
    }
}
